import React, { Component } from "react"
import Img from "gatsby-image"
import $ from "jquery"
import "lightgallery"
import "lg-video"
import "lg-zoom"

import "./floorplan.sass"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

class Floorplan extends Component {
  onLightGallery = node => {
    this.lightGallery = node
    $(node).lightGallery()
  }

  componentWillUnmount() {
    $(this.lightGallery)
      .data("lightGallery")
      .destroy(true)
  }

  render() {
    return (
      <div className="floorplan">
        <div className="card">
          <div className="floorplan-img">
            <Img
              fluid={this.props.src}
              alt="Typical 1 Bedroom floorplan"
              className="plan"
            />
          </div>
          <div className="plan-info">
            <h3 className="plan-title">{this.props.planTitle}</h3>
            <div className="plan-specs">
              <div className="spec-name">
                <span>enclosed area</span>
                <span>outdoor space</span>
                <span>total area</span>
              </div>
              <div className="spec-number">
                <span>
                  {this.props.enclosed} <sup>2</sup>
                </span>
                <span>
                  {this.props.outdoor} <sup>2</sup>
                </span>
                <span>
                  {this.props.total} <sup>2</sup>
                </span>
              </div>
            </div>
          </div>
        </div>
        <span ref={this.onLightGallery}>
          <a
            href={this.props.href}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-solid"
          >
            view floorplan
            <FontAwesomeIcon
              icon={["fal", "search-plus"]}
              className="fa-icon"
            />
          </a>
        </span>
      </div>
    )
  }
}

export default Floorplan
